module.exports = __webpack_public_path__ + "resources/img/img_sectigo_ssl2_en.75feb5d3ba40d78ecfbc48fda74fd9f5.png";